import { DXFAction } from './DXFAction';

export class DXFTranslateAction implements DXFAction {
  constructor(public readonly dx: number, public readonly dy: number) {}
}
